import "./tabs.scss";

const selectors = {
  container: "[data-tabs]",
  tabsHeader: "[data-tabs-header]",
  tabsPane: "[data-tabs-pane]",

  active: "active",
};

const getActiveTab = (headers) => {
  const hash = window.location.hash;

  if (!hash) return;

  return [...headers].findIndex(
    (header) => header.dataset.tabsHeader === decodeURI(hash).replace("#", "")
  );
};

const handleTabClick = (activeIndex, headers, panes) => {
  headers.forEach((header, index) => {
    panes[index].classList[activeIndex === index ? "add" : "remove"](
      selectors.active
    );
    header.classList[activeIndex === index ? "add" : "remove"](
      selectors.active
    );
  });
};

const initTabs = (container) => {
  const headers = container.querySelectorAll(selectors.tabsHeader);
  const panes = container.querySelectorAll(selectors.tabsPane);

  headers?.forEach((header, activeIndex) => {
    const button = header.querySelector("button");

    button.addEventListener("click", () =>
      handleTabClick(activeIndex, headers, panes)
    );
  });

  handleTabClick(getActiveTab(headers) || 0, headers, panes);
};

document.addEventListener("DOMContentLoaded", async function () {
  const containers = document.querySelectorAll(selectors.container);

  containers?.forEach(initTabs);
});
